export default "/images/GeorgeRigas.jpg?9fab416528937f20ff8fc3e97cd9ac33";